<nz-tabset nzType="card" [(nzSelectedIndex)]="selectedTabIndex">
  <!-- create message tab-->
  <nz-tab nzTitle="Create Message">
    <div nz-row nzJustify="space-between" style="border-radius: 5px;">
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" nzXXl="12" class="text-center" style="border-radius: 5px;">
        <nz-card nzTitle="New Message">
          <nz-spin [nzSpinning]="isSending" style="min-height: 300px;">
          <div style="max-height: 75vh; overflow-y: auto; padding-left:6px; padding-right:6px;">
            <app-new-comm (sendMessage)="onNewMessage($event)" 
            (previewMessage)="onPreviewChanged($event)" 
            [availableRecipients]="availableRecipients()"/>
          </div>
          </nz-spin>
        </nz-card>
      </div>
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" nzXXl="12" class="text-center" style="border-radius: 5px; max-height: 75vh; overflow-y: auto;">
        <nz-card nzTitle="Preview" style="height: fit-content">
          <div style="margin-bottom: 24px" *ngIf="!currentPreview?.messageLong && !currentPreview?.message">
            <p>No message to preview</p>
          </div>
          <div style="margin-bottom: 24px;" *ngIf="currentPreview?.messageLong || currentPreview?.message">
            <nz-card [nzBordered]="true">
              <div style="position: relative; min-height: 200px;">
                <div style="margin-bottom: 70px; margin-top: -70px;">
                  <button nz-button 
                          nzType="primary" 
                          [disabled]="true"
                          style="float: right; background-color: var(--backcolor); border: none !important; height: 50px; border-radius: 25px;">
                    <span nz-icon nzType="delete" nzTheme="outline" style="font-size: 1.5rem !important;"></span> 
                  </button>
                </div>
                <div>
                  <p class="float-right tm">{{ getCurrentDate().toString() + 'Z' | date:'medium' }}</p>
                </div>
                <br>
                <div class="message">
                  <span *ngIf="currentPreview?.message != ''">
                    {{ currentPreview?.message }}
                    <hr>
                  </span>
                  <div *ngIf="currentPreview?.messageLong" style="white-space: pre-wrap; text-align: left;" [innerHTML]="sanitizeHtml(currentPreview?.messageLong)">
                  </div>
                  <br>
                  <br>
                  <span *ngIf="currentPreview && currentPreview.pdfBase64 != null">
                    <button nz-button 
                            nzType="primary" 
                            (click)="openPdf(currentPreview.pdfBase64)" >
                      Open PDF
                      <span nz-icon nzType="sf:externalSVG" nzTheme="outline"></span>
                    </button>
                  </span>
            <hr>
            <div *ngIf="currentPreview?.poll">
              <p >Poll: {{currentPreview?.poll?.questionText}}</p>
              <nz-radio-group [ngModel]="currentPreview?.pollResponse?.selectedPollResponseOptionId">
                <label nz-radio *ngFor="let option of currentPreview?.poll?.responseOptions" style="margin-bottom: 8px;" [nzValue]="option.pollResponseOptionId" >
                  {{option.optionText}}
                </label>
                </nz-radio-group>
            </div>
                </div>                
              </div>
            </nz-card>
            <div style="text-align: center; margin-top: 8px; color: #999; font-size: 12px;">
              <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              This is how your message will appear to recipients
            </div>
          </div> 
        </nz-card>
        
        <nz-card nzTitle="Message Distribution">
          <div *ngIf="currentPreview?.sendConfig">
            <nz-collapse nzBordered="false">
              <nz-collapse-panel *ngIf="currentPreview?.sendConfig?.franchiseIds?.length"
              [nzHeader]="franchisesHeader"
              [nzActive]="false">
          <ng-template #franchisesHeader>
            <div style="display: flex; align-items: center;">
              <span style="font-weight: 500;">Franchises</span>
              <nz-badge [nzCount]="currentPreview?.sendConfig?.franchiseIds?.length" 
                  style="margin-left: 8px;"></nz-badge>
            </div>
          </ng-template>
          <p style="color: #666; margin-bottom: 12px; font-style: italic;">
            Only users from these franchises will receive the message:
          </p>
          <nz-list nzSize="small">
            <nz-list-item *ngFor="let franchiseId of currentPreview?.sendConfig?.franchiseIds">
              {{ getFranchiseName(franchiseId) }}
            </nz-list-item>
          </nz-list>
              </nz-collapse-panel>
              <nz-collapse-panel *ngIf="currentPreview?.sendConfig?.clientIds?.length"
              [nzHeader]="branchesHeader"
              [nzActive]="false">
          <ng-template #branchesHeader>
            <div style="display: flex; align-items: center;">
              <span style="font-weight: 500;">Branches</span>
              <nz-badge [nzCount]="currentPreview?.sendConfig?.clientIds?.length" 
                  style="margin-left: 8px;"></nz-badge>
            </div>
          </ng-template>
          <p style="color: #666; margin-bottom: 12px; font-style: italic;">
            Only users from these branches will receive the message:
          </p>
          <nz-list nzSize="small">
            <nz-list-item *ngFor="let clientId of currentPreview?.sendConfig?.clientIds">
              {{ getClientName(clientId) }}
            </nz-list-item>
          </nz-list>
              </nz-collapse-panel>
              <nz-collapse-panel *ngIf="currentPreview?.sendConfig?.roleIds?.length"
              [nzHeader]="rolesHeader"
              [nzActive]="false">
          <ng-template #rolesHeader>
            <div style="display: flex; align-items: center;">
              <span style="font-weight: 500;">User Roles</span>
              <nz-badge [nzCount]="currentPreview?.sendConfig?.roleIds?.length" 
                  style="margin-left: 8px;"></nz-badge>
            </div>
          </ng-template>
          <p style="color: #666; margin-bottom: 12px; font-style: italic;">
            Users with any of these roles will receive the message:
          </p>
          <nz-list nzSize="small">
            <nz-list-item *ngFor="let roleId of currentPreview?.sendConfig?.roleIds">
              {{ getRoleName(roleId) }}
            </nz-list-item>
          </nz-list>
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </nz-card>
      </div>
    </div>
  </nz-tab>

  <!-- edit message tab -->
  <nz-tab nzTitle="Sent Messages">
    <div nz-row nzJustify="space-between" style="border-radius: 5px;">
      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" nzXXl="12" class="text-center" style="border-radius: 5px;">
        <nz-card nzTitle="Sent Messages" >
          <!-- <ng-template #extraTemplate>
            <nz-badge [nzCount]="sentMessages.length" [nzOverflowCount]="99">
              <span nz-icon nzType="message" nzTheme="outline"></span>
            </nz-badge>
          </ng-template> -->

          <div style="max-height: 70vh; overflow-y: auto;">
            
            <nz-spin [nzSpinning]="isLoadingSentMessages" *ngIf="isLoadingSentMessages">
              <div style="height: 100px;"></div>
            </nz-spin>

            <div *ngIf="!isLoadingSentMessages">
              <div *ngFor="let message of sentMessages()" 
                 style="padding: 12px; border-bottom: 1px solid #f0f0f0;">
              
              <div style="font-weight: 500; margin-bottom: 4px; display: flex; justify-content: space-between; align-items: center;">
                <h4 >
                {{ message.message || 'Untitled Message' }}

                </h4>
                <div nz-col style="display: flex; gap: 12px;">
                  <button nz-button nzType="default" (click)="openMessageRecipients(message.messageGroupUuid); $event.stopPropagation()" nz-tooltip="View Recipients">
                    <span nz-icon nzType="eye" nzTheme="outline"></span>
                  </button>
                  <button nz-button nzType="default"   
                      (click)="deleteMessage(message.messageGroupUuid); $event.stopPropagation()"
                      nz-tooltip="Delete">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                </div>
              </div>

              <div style="font-size: 12px; color: #8c8c8c; display: flex; justify-content: left;">
                {{ message.dtCreated | date:'medium' }} • {{ getMessagePreview(message.messageLong) }}
              </div>

              <nz-collapse nzBordered="false" style="margin-top: 8px;">
                <nz-collapse-panel [nzHeader]="'Show Full Message'" [nzActive]="false">
                <div style="white-space: pre-wrap; text-align: left;" [innerHTML]="sanitizeHtml(message.messageLong || message.message)">
                </div>
                <div *ngIf="message.pdfBase64">
              <button nz-button nzType="primary" (click)="openPdf(message.pdfBase64)">Open PDF <span nz-icon nzType="file" nzTheme="outline" ></span></button>
            </div>
                        <hr>
            <div *ngIf="message?.poll">
              <p >Poll: {{message?.poll?.questionText}}</p>
              <nz-radio-group >
                <label nz-radio *ngFor="let option of message?.poll?.responseOptions" style="margin-bottom: 8px;" [nzValue]="option.pollResponseOptionId" >
                  {{option.optionText}}
                </label>
                </nz-radio-group>
            </div>
                
                </nz-collapse-panel>
              </nz-collapse>
              </div>
            </div>
            <div *ngIf="sentMessages().length === 0 && !isLoadingSentMessages" 
                 style="text-align: center;">
              <!-- <span nz-icon nzType="inbox" nzTheme="outline" style="font-size: 32px; display: block; margin-bottom: 8px;"></span> -->
              <p>No messages sent yet</p>
            </div>
          </div>
        </nz-card>
      </div>

      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" nzXXl="12" class="text-center" style="border-radius: 5px;">
        <!-- <nz-card nzTitle="Edit Message" >
          <app-new-comm   />
        </nz-card> -->
        <nz-card nzTitle="Message Recipients" >
          <div style="height: 70vh; overflow-y: auto; text-align: center; color: #999; padding: 12px;">
              <nz-table #basicTable [nzData]="selectedMessageRecipients()" [nzLoading]="isLoadingRecipients" [nzFrontPagination]="false" style="width: 100%; height:100%" *ngIf="!isLoadingRecipients && selectedMessageRecipients" [nzFrontPagination]="true" [nzPageSize]="10">
          <thead>
            <tr>
              <th>Name</th>
              <th>Cell</th>
              <th [nzFilters]="franchiseNames" [nzFilterFn]="filterByFranchiseNameFn">Franchise</th>
              <th [nzFilters]="branchNames" [nzFilterFn]="filterByBranchNameFn">Branch</th>
              <th [nzFilters]="isViewed" [nzFilterFn]="filterByIsViewedFn">Viewed</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let recipient of basicTable.data">
              <td>{{ recipient.name }}</td>
              <td>{{ recipient.cell }}</td>
              <td>{{ recipient.franchise }}</td>
              <td>{{ recipient.branch }}</td>
              <td>
                <span *ngIf="recipient.dtRead; else notViewed">
            <span nz-icon nzType="check-circle" nzTheme="outline" style="color: #52c41a;" [nz-tooltip]="recipient.dtRead ? (recipient.dtRead | date:'medium') : ''"></span>
                </span>
                <ng-template #notViewed>
            <span nz-icon nzType="close-circle" nzTheme="outline" style="color: #f5222d;"></span>
                </ng-template>
              </td>
            </tr>
          </tbody>
              </nz-table>         
          </div>
        </nz-card>
      </div>
    </div>
  </nz-tab>
</nz-tabset>


